import React, { useEffect, useState } from 'react'

import { getInventoryPrograms } from 'api'

import { ProgramCard } from './components/Card'
import { CardsContainer } from './styles'

import { transformProgramCards } from '../../transformers'

const ProgramCards = ({ selectedBatchType, selectedCentres, onCardClick }) => {
  const [programCardsData, setProgramCardsData] = useState([])

  useEffect(() => {
    ;(async () => {
      if (selectedCentres) {
        const programsResponse = await getInventoryPrograms({
          queries: {
            type: selectedBatchType,
            centre_uuid: selectedCentres?.value ?? undefined
          }
        })
        setProgramCardsData(transformProgramCards(programsResponse))
      }
    })()
  }, [selectedCentres, selectedBatchType])

  return (
    <CardsContainer>
      {programCardsData?.map((card) => (
        <ProgramCard
          onCardClick={() => onCardClick(card)}
          card={card}
          key={card.uuid}
        />
      ))}
    </CardsContainer>
  )
}
export default ProgramCards
